export default __webpack_public_path__ + "media/f5fa0e03bd853bd71e8935a3e96548e67de9e062b61ccea22034eac11684c81a.svg";